export const API_URL = process.env.REACT_APP_API_URL || "https://api.pxnres.com";
export const DEMO_REPORT_URL = "https://download.protestingpropertytaxes.com/demo_report.pdf";
export const DEMO_FILING_GUIDE_URL = "https://download.protestingpropertytaxes.com/demo_filing_guide.pdf";

export const SUBSCRIPTION_PRICE = 99;
export const ONE_TIME_PRICE = 179;

export const FREE_ASSESSMENT_PROPERTY_PRICE = 200000;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const TAX_YEAR = process.env.REACT_APP_TAX_YEAR;
export const UNBOUNCE_LOCALSTORAGE_KEY = "unbounce_submitted";
export const UNBOUNCE_SUBMITED_TIMESTAMP = "unbounce_submitted_timestamp";
// ASSESSES_AFTER is deliberately gone. It was
// REACT_APP_LAST_VALID_APPRAISAL_DATE, a date frozen into the bundle at
// build time and sent as the roll-coverage window. The server's window
// rolls (today - 365); a baked constant cannot. They drifted apart by a
// day per day until the search box and the Texas cascade disagreed about
// which parcels we hold. The server now owns the window; send no date.
export const EIGHT_HOURS_MS = 28800000; // 8 hours in milliseconds
export const BROKER_REFERRAL_SESSION_STORAGE_KEY = "broker_referral_code";
export const SUPPORT_EMAIL = "help@protestingpropertytaxes.com";
export const MAP_BBOX_OFFSET = 0.001;
export const isPreOrderFlow = process.env.REACT_APP_PRE_ORDER_FLOW === 'true';

// Customer accounts — ENABLED BY DEFAULT (no env var needed). Set
// REACT_APP_ACCOUNTS_ENABLED="false" only as a kill switch to hide all account
// UI (the "Sign in" nav entry).
export const ACCOUNTS_ENABLED = process.env.REACT_APP_ACCOUNTS_ENABLED !== 'false';

export const ReportPlanType = {
  ONE_TIME: "One-time",
  YEARLY: "Yearly",
};

export const ReportStep = {
  ESTIMATE: 0,
  PAYMENT_SUCCESSFUL: 1,
  SELECT_REPORT_TYPE: 2,
};
